import Constants from "../constants";
import { CROSSHAIR_SIZE_PX } from "../components/ui/CrosshairPreloader";

// crosshair-controller.ts
export class CrosshairController {
  private element: HTMLElement | null = null;

  constructor() {
    // Run once – or call this method when you know DOM is ready
    this.findElement();

    this.hide();
  }

  private findElement() {
    this.element = document.getElementById(Constants.UI_CROSSHAIR_ID);
    if (!this.element) {
      console.warn('Crosshair element not found yet');
      // Optional: retry once after delay if portal mounts slowly
      setTimeout(() => this.findElement(), 300);
    }
  }

  // Main method you will call
  setPosition(x: number, y: number, unit: 'px' | '%' | 'vw' | 'em' = 'px') {
    if (!this.element) {
      this.findElement();
      if (!this.element) return;
    }

    x -= CROSSHAIR_SIZE_PX / 2;
    y -= CROSSHAIR_SIZE_PX / 2; // Slightly above the finger

    this.element.style.left = `${x}${unit}`;
    this.element.style.top  = `${y}${unit}`;

    this.show();
  }

  // Convenience methods
  center() {
    this.setPosition(50, 50, '%');
    this.element!.style.transform = 'translate(-50%, -50%)';
  }

  offsetFromCenter(dxPx: number, dyPx: number) {
    this.center();
    if (this.element) {
      this.element.style.transform = `translate(calc(-50% + ${dxPx}px), calc(-50% + ${dyPx}px))`;
    }
  }

  hide() {
    if (this.element) this.element.style.display = 'none';
  }

  show() {
    if (this.element) this.element.style.display = '';
  }

  setSize(w: number | string, h?: number | string) {
    if (!this.element) return;
    this.element.style.width  = typeof w === 'number' ? `${w}px` : w;
    this.element.style.height = h !== undefined 
      ? (typeof h === 'number' ? `${h}px` : h)
      : (typeof w === 'number' ? `${w}px` : w);
  }

  setPhysicalSizeCm(widthCm: number, heightCm: number = widthCm) {
    if (!this.element) return;

    const dpi = window.devicePixelRatio * 96; // rough physical DPI estimate
    // 96 = CSS reference dpi

    const widthPx = (widthCm * dpi) / 2.54;   // cm → inches → css px
    const heightPx = (heightCm * dpi) / 2.54;

    this.element.style.width = `${widthPx}px`;
    this.element.style.height = `${heightPx}px`;
  }
}